module.exports = __webpack_public_path__ + "img/minter.a387f17b.gif";